import { graphql } from 'react-relay';

/**
 * The `Apis.Admin` feature-flag query rendered by the walking skeleton. Lives in
 * `relay/` (not a screen) so the `graphql` tag is confined to data modules that
 * go through the Babel transform — screens stay transform-free and testable.
 */
export const featureFlagsQuery = graphql`
    query featureFlagsQuery {
        featureFlags {
            key
            stage
            killed
            percent
            kind
        }
    }
`;
